import { TDataFromStepOne } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const validationOfPriceListRules = ({
  calculationId,
  payload,
}: {
  calculationId?: string | undefined;
  payload: TDataFromStepOne;
}) => {
  return API.post('/api/accommodation/reservation/validate', payload, {
    params: { calculationIdToIgnore: calculationId },
  });
};
